import { render, staticRenderFns } from "./assessResult.vue?vue&type=template&id=2d2a786e&scoped=true&"
import script from "./assessResult.vue?vue&type=script&lang=js&"
export * from "./assessResult.vue?vue&type=script&lang=js&"
import style0 from "./assessResult.vue?vue&type=style&index=0&id=2d2a786e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a786e",
  null
  
)

export default component.exports